import type { ChangeEvent, HTMLAttributes } from 'react';
import { FloatingLabelInputLayout } from 'framework/ui/layout';
import { FillInputProps } from '../fillInput';
import { oneLine } from 'framework/utils';

type Handed = Pick<
  FillInputProps<string, object>,
  | 'inputId'
  | 'label'
  | 'showLabel'
  | 'describedBy'
  | 'value'
  | 'onChange'
  | 'onBlur'
  | 'disabled'
  | 'required'
  | 'error'
>;

interface TextInputProps extends Handed {
  multiline?: boolean;
  spellCheck?: boolean;
  maxLength?: number;
  inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
  keep?: (typed: string) => string;
}

export const TextInput = (props: TextInputProps) => {
  const {
    inputId,
    label,
    showLabel,
    describedBy,
    value,
    onChange,
    onBlur,
    disabled,
    required,
    error,
    multiline = false,
    spellCheck = false,
    maxLength,
    inputMode,
    keep,
  } = props;
  const change = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const typed = event.target.value;
    onChange(keep ? keep(typed) : typed);
  };
  return (
    <FloatingLabelInputLayout
      source={inputId}
      label={showLabel ? label : undefined}
      multiline={multiline}
      value={multiline ? value : oneLine(value)}
      disabled={disabled}
      isRequired={required}
      errorMessages={error ? [''] : []}
      sx={{ mb: 0 }}
      slotProps={{
        input: { minRows: multiline ? 3 : undefined },
        inputLabel: { shrink: showLabel || undefined },
        htmlInput: {
          onChange: change,
          onBlur,
          spellCheck,
          maxLength,
          inputMode,
          autoComplete: 'off',
          'aria-describedby': describedBy,
          'aria-required': required || undefined,
        },
      }}
    />
  );
};
